/**
 * Store Error Interface
 *
 * Structured error object used in state management store state
 * Replaces plain string errors with typed error objects containing code + message
 */

/**
 * Store Error - Structured error for state management store
 *
 * @property code - Error code (e.g., 'AUTH_001', 'BUS_004')
 * @property message - User-friendly error message
 * @property category - Error category for proper handling
 *
 * @example
 * const error: StoreError = {
 *   code: ErrorCodes.AUTH_UNAUTHENTICATED,
 *   message: 'Your session has expired',
 *   category: 'auth'
 * };
 */
export interface StoreError {
  /** Error code following CAT_0xx convention */
  code: string;

  /** User-friendly error message */
  message: string;

  /** Error category for categorized handling */
  category?: 'auth' | 'validation' | 'business' | 'network' | 'server';
}

/**
 * Helper to create a StoreError from AppError
 * Converts Result pattern errors to Store-friendly format
 *
 * @param error - AppError from Result pattern
 * @returns StoreError for state management store
 */
export function toStoreError(error: {
  code: string;
  message: string;
  category?: string;
}): StoreError {
  return {
    code: error.code,
    message: error.message,
    category: error.category as StoreError['category'],
  };
}
